import React, { useState, useEffect } from "react";

import "../styles/AdminEvents.css";

function AdminEvents() {
  const [events, setEvents] = useState([]);
  const [form, setForm] = useState({
    title: "",
    description: "",
    location: "",
    date_start: "",
    published: false,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    setError("");
    try {
      const res = await fetch("https://alaiak.eus/api/alaiak/admin/events", { credentials: "include" });
      if (!res.ok) throw new Error("No autorizado o error de red");
      const data = await res.json();
      setEvents(data);
    } catch (err) {
      setError(err.message);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      let res;
      if (editingId) {
        res = await fetch(`https://alaiak.eus/api/alaiak/admin/events/${editingId}`, {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            ...form,
            date_start: form.date_start ? new Date(form.date_start).toISOString() : null,
            date_end: null,
          }),
        });
        if (!res.ok) throw new Error("Error al actualizar evento");
      } else {
        res = await fetch("https://alaiak.eus/api/alaiak/admin/events", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            ...form,
            date_start: form.date_start ? new Date(form.date_start).toISOString() : null,
            date_end: null,
          }),
        });
        if (!res.ok) throw new Error("Error al crear evento");
      }
      setForm({ title: "", description: "", location: "", date_start: "", published: false });
      setEditingId(null);
      await fetchEvents();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  const handleEdit = (ev) => {
    setForm({
      title: ev.title || "",
      description: ev.description || "",
      location: ev.location || "",
      date_start: ev.date_start ? new Date(ev.date_start).toISOString().slice(0, 16) : "",
      published: !!ev.published,
    });
    setEditingId(ev.id);
  };

  const handleCancelEdit = () => {
    setForm({ title: "", description: "", location: "", date_start: "", published: false });
    setEditingId(null);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("¿Eliminar este evento?")) return;
    setError("");
    try {
      const res = await fetch(`https://alaiak.eus/api/alaiak/admin/events/${id}`, {
        method: "DELETE",
        credentials: "include",
      });
      if (!res.ok) throw new Error("Error al borrar evento");
      await fetchEvents();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="admin-events-panel">
      <h2>Gestión de Eventos</h2>
      <form onSubmit={handleSubmit} className="admin-events-form">
        <input name="title" value={form.title} onChange={handleChange} placeholder="Título" required />
        <input name="location" value={form.location} onChange={handleChange} placeholder="Localización" />
        <textarea name="description" value={form.description} onChange={handleChange} placeholder="Descripción" />
        <label>
          Día y hora:
          <input type="datetime-local" name="date_start" value={form.date_start} onChange={handleChange} required />
        </label>
        <label>
          <input type="checkbox" name="published" checked={form.published} onChange={handleChange} /> Publicado
        </label>
        <button type="submit" disabled={loading}>
          {loading ? (editingId ? "Guardando..." : "Creando...") : (editingId ? "Guardar Cambios" : "Crear Evento")}
        </button>
        {editingId && (
          <button type="button" onClick={handleCancelEdit} disabled={loading} className="admin-events-cancel">Cancelar</button>
        )}
      </form>
      {error && <div className="admin-events-error">{error}</div>}
      <div className="admin-events-list">
        {events.length === 0 ? (
          <div className="admin-events-empty">No hay eventos.</div>
        ) : (
          <table className="admin-events-table">
            <thead>
              <tr>
                <th>Título</th>
                <th>Localización</th>
                <th>Día y hora</th>
                <th>Publicado</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {events.map((ev) => (
                <tr key={ev.id}>
                  <td>{ev.title}</td>
                  <td>{ev.location}</td>
                  <td>{ev.date_start && new Date(ev.date_start).toLocaleString()}</td>
                  <td>{ev.published ? "Sí" : "No"}</td>
                  <td>
                    <button onClick={() => handleEdit(ev)} className="admin-events-edit">Editar</button>
                    <button onClick={() => handleDelete(ev.id)} className="admin-events-delete">Borrar</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default AdminEvents;
